import { createStyles } from '@material-ui/core/styles';

export const EnhancedTableToolbarStyles = theme =>
  createStyles({
    enhancedTableToolbarRoot: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
      padding: 10,
      borderBottom: `1px solid ${theme.color.lightgray}`
    },
    enhancedTableToolbarSpacer: {
      flex: '1 1 100%'
    },
    enhancedTableToolbarActions: {
      color: theme.palette.text.secondary,
      display: 'flex'
    },
    enhancedTableToolbar_TitleRow: {
      flex: '0 0 auto',
      display: 'flex'
    },
    enhancedTableToolbarLinkButton: {
      '&:hover': {
        textDecoration: 'none'
      }
    },
    enchancedTableToolbar_Button: {
      boxShadow: 'none',
      fontWeight: theme.typography.weight.bold,
      color: theme.color.gray,
      borderRadius: 25,
      textTransform: 'none',
      padding: '10px 25px',
      marginLeft: 20
    },
    enchancedTableToolbar_ChartButton: {
      '&:hover': {
        backgroundColor: '#c11319'
      },
      backgroundColor: theme.color.red,
      color: 'white',
      border: 'none'
    },
    enhancedTableToolbar_ButtonBadge: {
      backgroundColor: '#aa1616',
      border: '1px solid white',
      right: 30
    },
    enhancedTableToolbarTextField: {
      //Searchbar
      boxShadow: 'inset 0px 0px 3px 3px rgba(0,0,0,0.04)',
      marginTop: '8px',
      borderRadius: '25px',
      backgroundColor: theme.color.lightgray,
      marginRight: theme.spacing(3),
      minWidth: 400,
      paddingTop: 7,
      paddingBottom: 7
    },
    enhancedTableToolbarIcon: {
      marginLeft: theme.spacing(2),
      color: theme.color.red
    },
    enhancedTableToolbar_CancelIcon: {
      color: theme.color.red
    },
    enhancedTableToolbarClearSearchButton: {
      cursor: 'default',
      marginRight: 10
    },
    enchancedTableToolbar_Title: {
      paddingTop: 10,
      paddingBottom: 10,
      paddingRight: 15,
      fontWeight: theme.typography.weight.bold,
      fontSize: 25,
      color: 'black'
    },
    enchancedTableToolbar_SubTitle: {
      paddingTop: 10,
      paddingBottom: 10,
      paddingRight: 15,
      fontWeight: theme.typography.weight.bold,

      fontSize: 13,
      color: 'black',
      position: 'absolute',
      top: 48,
      left: 17
    },
    enchancedTableToolbar_SubTitleLink: {
      color: 'red'
    }
  });
